import { useMutation } from '@apollo/client';
import { useTranslation } from 'react-i18next';
import { CREATE_PDA_HOME_MENUS } from '../graphql/queries';

export const useSavePdaMenuConfig = () => {
  const { t } = useTranslation();
  const [createMutation, { loading }] = useMutation(CREATE_PDA_HOME_MENUS);

  const save = async (input: { 
    warehouseId: number; 
    accountRole: string; 
    menuConfigIds: number[];
    isEdit?: boolean;
  }) => {
    try {
      const { data } = await createMutation({
        variables: {
          input: {
            ...input,
            isEdit: input.isEdit || false,
          },
        },
      });
      return { success: data?.createPdaHomeMenus === true, error: null };
    } catch (error: any) {
      console.error('Save PDA menu config error:', error);
      
      // 尝试从错误信息中提取 message key 并进行国际化
      let errorMessage = t('errors.business.pdaHomeConfig.saveFailed');
      
      if (error?.message) {
        const rawMessage = error.message;
        
        // 如果错误消息包含 errors.business.pdaHomeConfig.alreadyExists
        if (rawMessage.includes('errors.business.pdaHomeConfig.alreadyExists')) {
          errorMessage = t('errors.business.pdaHomeConfig.alreadyExists');
        } else {
          // 使用原始错误消息
          errorMessage = rawMessage;
        }
      }
      
      return { success: false, error: errorMessage };
    }
  };

  return {
    save,
    loading,
  };
};
